import { Component, OnInit } from '@angular/core';
import { Headers } from '@angular/http';
import { Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';

import { MainService } from 'app/resources/services/index';
import { DefineBootboxId } from 'app/resources/classes';
import 'bootbox';

@Component({
  selector: 'app-bandeirado',
  templateUrl: './bandeirado.component.html'
})
export class BandeiradoComponent implements OnInit {

  public processando: boolean;
  public transferencia: any;
  public taxaTransferencia: number = undefined;
  public saldoService = this.mainService.saldoService;
  public valorMoeda: number;
  public valorPontos: number;
  public epwd = undefined;
  public avisoTransf: boolean;
  public limiteTransferencia = undefined;
  public concordo: boolean;
  public debitoPontos: number;
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();

  constructor(public mainService: MainService, public router: Router,
    location: LocationStrategy) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.processando = false;
    this.valorMoeda = 0;
    this.valorPontos = 0;
    this.avisoTransf = false;
    this.concordo = false;
    this.debitoPontos = 700;
    this.getTaxaTransferencia();
    this.getLimiteTransferencia();
    this.mainService.saldoService.initialize();
  }

  public calculaValorPontos() {
    this.debitoPontos = this.mainService.servicesService.moedaToPontos(
      this.valorMoeda, this.mainService.cartaoService.cartao.indiceMoeda) + this.taxaTransferencia;
  };

  public liberaTransferencia() {
    this.avisoTransf = true;
  };

  public save() {

    this.transferencia = {};
    this.transferencia.valorMoeda = this.valorMoeda;

    const cabecalho: Headers = new Headers();
    cabecalho.append('Authorization', 'Basic ' + this.mainService.sessionService.getAuthBasic());
    cabecalho.append('X-Auth-Ep', this.epwd);
    const url = 'auth/users/transferencias/bandeirados/';
    this.mainService.http.pathV2().post(url, this.transferencia, true, cabecalho)
      .subscribe(
      sucesso => {
        this.mainService.saldoService.initialize();
        this.router.navigate(['/transferencias']);
        this.bootboxAlertComId.alerta('A transferência para cartão bandeirado foi realizada com sucesso!');
      }, error => {
        this.bootboxAlertComId.alerta(error.text());
      });
  };

  public getTaxaTransferencia() {

    this.mainService.http.pathV2().get('auth/users/transferencias/bandeirados/tarifa/', true)
      .subscribe(
      sucesso => {
        this.taxaTransferencia = parseInt(sucesso.json(), 10);
      });
  };

  public getLimiteTransferencia() {

    this.mainService.http.pathV2().get('auth/users/transferencias/bandeirados/limite/', true)
      .subscribe(
      sucesso => {
        this.limiteTransferencia = parseFloat(sucesso.json());
      });
  };
}



// WEBPACK FOOTER //
// ./src/app/transferencia/bandeirado/bandeirado.component.ts